import { useMemo } from 'react';
import type { SurveyTemplate } from '../../domain/SurveyTemplates/SurveyTemplate';
import type { CategoryInfo } from '../common/model/Category';

export const useSurveyTemplatesFromCategoryWithSearch = (
  templates: SurveyTemplate[] | undefined,
  categoryInfo: CategoryInfo | undefined,
  search: string,
): SurveyTemplate[] => {
  return useMemo<SurveyTemplate[]>(() => {
    if (templates === undefined || categoryInfo === undefined) {
      return [];
    }

    if (search) {
      const query = search.toLowerCase();
      return templates.filter(
        (template) =>
          template.title.toLowerCase().includes(query) ||
          template.intro_text.toLowerCase().includes(query),
      );
    }

    return templates.filter(categoryInfo.filter);
  }, [categoryInfo, templates, search]);
};
